import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

export interface ISubmitBidApplicationParams {
  cycleId: string;
  answers: Record<string, string>;
  mailingAddress: string;
  termsAccepted: boolean;
}

/**
 * Backend expects `answers`, `mailingAddress`, and `termsAccepted` as
 * top-level body fields; `cycleId` goes in the URL path.
 */
export const submitBidApplication = async (params: ISubmitBidApplicationParams): Promise<void> => {
  const { cycleId, ...body } = params;
  const headers = await getAuthHeaders();
  await tempMeeApi.post(`${AWARDS_API_PREFIX}/cycles/${cycleId}/applications`, body, { headers });
};
